import { defineMessages } from "react-intl";

export const defaultListMessages = defineMessages({
  error: { id: "default.error", defaultMessage: "An error occurred" },
  loading: { id: "default.loading", defaultMessage: "Loading..." },
  loadError: { id: "default.loadError", defaultMessage: "Load Error" },
  loadRetry: { id: "default.retry", defaultMessage: "Retry" },
  noData: { id: "default.noData", defaultMessage: "No Data" },
  entityName: { id: "default.entity", defaultMessage: "Entity" },
  tableActions: { id: "default.tableActions", defaultMessage: "Actions" },
  reorderFailedTitle: { id: "default.reorderFailedTitle", defaultMessage: "Reordering failed" },
  reorderFailedContent: {
    id: "default.reorderFailedContent",
    defaultMessage: "An error occurred while trying to reorder the elements.",
  },
  saveSuccess: { id: "default.saveSuccess", defaultMessage: "Saved successfully" },
  filtersTitle: { id: "default.filters", defaultMessage: "Filters" },
  filter: { id: "default.filter", defaultMessage: "Filter" },
  clearFilters: { id: "default.clearFilters", defaultMessage: "Filter" },
  export: { id: "default.export", defaultMessage: "Export" },
  columns: { id: "default.columns", defaultMessage: "Columns" },
  resultPerPage: { id: "default.resultPerPage", defaultMessage: "Results per page:" },
  import: { id: "default.import", defaultMessage: "Import" },
  batchCancellation: { id: "default.batchCancellation", defaultMessage: "BatchCancellation" },
  bulkUpdate: { id: "default.bulkUpdate", defaultMessage: "Bulk update" },
  edit: {
    id: "app.entityForm.edit",
    defaultMessage: "Edit",
  },
});
